export default {
    type: {
        type: String,
        default: 'button',
        required: false
    },
    color: {
        type: String,
        default: 'grey',
        required: false
    },
    size: {
        type: String,
        default: 'mid',
        required: false
    },
    borderColor: {
        type: String,
        default: '',
        required: false
    }
}